<template>
  <button
    type="button"
    class="c-bg-transparent brdr-none inline-flex c-white p0"
    :aria-label="$t('Open menu')"
    data-testid="menuButton"
    @click="openSidebarMenu"
  >
    <i class="icon icon-ev-hamburger w-100 h-100" />
  </button>
</template>

<script>
import HamburgerIcon from '@vue-storefront/core/compatibility/components/blocks/Header/HamburgerIcon'

export default {
  mixins: [HamburgerIcon]
}
</script>
